module.exports = __webpack_public_path__ + "img/SLT_0826-Bearbeitet.fc4c2744.jpg";